module.exports = __webpack_public_path__ + "img/edytuj.0cec20f8.svg";